import React from 'react';
import TabBar, { TabBarProps } from '../../../../shared/components/TabBar';
import FormContainer from '../Content/FormContainer';
import MaterialStandard from '../Content/MaterialStandard';
import { Product } from '../../../../data/entities';
import { ProductCustomerTab } from '../Content/Customer';
import ProductExtraFees from '../Content/ProductExtraFee';

interface TabNavigationProps {
    validated: boolean;
    productData: Product;
    mergeProduct: Function;
}

const TabNavigation = ({ validated, productData, mergeProduct }: TabNavigationProps) => {
    const tabs: TabBarProps[] = [
        {
            label: 'Thông tin',
            labelEN: 'info',
            content: <FormContainer validated={validated} mergeProduct={mergeProduct} productData={productData} />,
        },
        {
            label: 'Định Mức Vật Tư',
            labelEN: 'material-standard',
            content: <MaterialStandard materials={productData.materials as any} mergeMaterial={mergeProduct} />,
        },
        {
            label: 'Chi phí kèm theo',
            labelEN: 'extra-fee',
            content: (
                <ProductExtraFees
                    extraFees={productData.extra_fees}
                    mergeProduct={mergeProduct}
                    category={productData.category}
                />
            ),
        },
        {
            label: 'Khách hàng',
            labelEN: 'customers',
            content: (
                <ProductCustomerTab
                    customers={productData.customers || []}
                    defaultPrice={0}
                    mergeProduct={mergeProduct}
                />
            ),
        },
    ];

    return <TabBar tabs={tabs} />;
};

export default TabNavigation;
